import React from "react";
import Avatar from "@material-ui/core/Avatar";
import Button from "@material-ui/core/Button";
import CssBaseline from "@material-ui/core/CssBaseline";
import TextField from "@material-ui/core/TextField";
import FormControlLabel from "@material-ui/core/FormControlLabel";
import Checkbox from "@material-ui/core/Checkbox";
import Link from "@material-ui/core/Link";
import Grid from "@material-ui/core/Grid";
import Box from "@material-ui/core/Box";
import LockOutlinedIcon from "@material-ui/icons/LockOutlined";
import Typography from "@material-ui/core/Typography";
import { makeStyles, withStyles } from "@material-ui/core/styles";
import Container from "@material-ui/core/Container";
import CircularProgress from "@material-ui/core/CircularProgress";
import SelectFilter from "react-select";
import Input from "@material-ui/core/Input";
import InputLabel from "@material-ui/core/InputLabel";
import DateTimePicker from "./controls/DateTimePicker";
import Datetime from "react-datetime";
import "react-datetime/css/react-datetime.css";
import ThoiTietEditDialog from "./danhmuc/ThoiTietEditDialog";
import MapViewControl from "./MapViewControl";
import localConfig from "local-storage";

const myLib = require("../lib/MyLib");
const server = require("../lib/server");

class LoginPage extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      canSaved: false, //cho phep save hay khong
      dataChanged: false, //du lieu co su thay doi hay khong
      saving: false, //co dang save du lieu hay khong
      errorLog: "", //mo ta loi neu co
      loading_coquan: false, // co dang load ding danh muc nguon tin ko
      source_coquan: [], //danh muc options cho nguon tin
      UserName: localConfig.get("username") === undefined ? '' : localConfig.get('username'),
      Password: "",
    };
  }

  componentDidMount() {
    this.loadDanhmuc();
  }
  loadDanhmuc() {
  }
  saveField = (fieldName, value) => {
    var s = this.state;
    s[fieldName] = value;
    s.dataChanged = true;
    s.canSaved = s.dataChanged;
    this.setState(s);
  };
  render() {
    const { classes, theme } = this.props;
    return (
      <Container component="main" maxWidth="xs">
        <CssBaseline />
        {1 === 0 ?
        <div style={{ width: 1500, height: 800 }}>
          <MapViewControl height={500} />
        </div>: null
        }
        {1 === 1 ? (
          <div className={classes.paper}>
            <Avatar className={classes.avatar}>
              <LockOutlinedIcon />
            </Avatar>
            <Typography component="h1" variant="h5">
              Đăng nhập
            </Typography>
            <form className={classes.form} noValidate>
              <TextField
                variant="outlined"
                margin="normal"
                required
                fullWidth
                id="email"
                label="Tài khoản:"
                name="email"
                autoFocus
                value={this.state.UserName}
                onChange={(event) =>
                  this.saveField("UserName", event.target.value)
                }
              />
              <TextField
                variant="outlined"
                margin="normal"
                required
                fullWidth
                name="password"
                label="Mật khẩu:"
                require
                type="password"
                id="password"
                autoComplete="current-password"
                onChange={(event) =>
                  this.saveField("Password", event.target.value)
                }
              />
              {this.state.saving ? (
                <CircularProgress />
              ) : (
                <Button
                  fullWidth
                  variant="contained"
                  color="primary"
                  disabled={this.state.Password === '' || this.state.UserName === ''}
                  className={classes.submit}
                  type="submit"
                  onClick={() => {
                    //submit login
                    this.setState({ saving: true, errorLog: "" });
                    var user = {
                      UserName: this.state.UserName,
                      Password: this.state.Password,
                    };
                    server
                      .post("user/login", user)
                      .then((response) => {
                        localConfig.set('username', user.UserName);
                        response.Quyen = JSON.parse(response.Quyen);
                        this.setState({
                          dataChanged: false,
                          canSaved: false,
                          saving: false,
                          errorLog: "",
                          saving: false,
                        });
                        if (this.props.onLogged) {
                          this.props.onLogged(true, response);
                        }
                      })
                      .catch((error) =>
                        this.setState({
                          saving: false,
                          errorLog: error + "",
                        })
                      );
                  }}
                >
                  Đăng nhập
                </Button>
              )}
              <Grid container>
                <Grid item xs>
                  <Typography>
                    {this.state.errorLog !== "" ? this.state.errorLog : null}
                  </Typography>
                </Grid>
              </Grid>
            </form>
          </div>
        ) : null}
        <Box mt={8}>
          <Typography variant="body2" color="textSecondary" align="center">
            {"Bản quyền © "}
            <Link color="inherit" href="https://www.vinamarine.gov.vn">
              Trung tâm Phối hợp Tìm kiếm Cứu nạn
            </Link>{" "}
            {new Date().getFullYear()}
            {"."}
          </Typography>
          {1 == 0 ? (
            <ThoiTietEditDialog
              visible={true}
              fullWidth={true}
              maxWidth={"xl"}
              MaKV={1}
              onClose={(result) =>
                this.setState(
                  {
                    open_edit_sukien: false,
                    Editting_MaKV: undefined,
                    showConfirmXoa: false,
                  },
                  () => {
                    if (result === true) this.handleSearch();
                  }
                )
              }
            />
          ) : null}
        </Box>
      </Container>
    );
  }
}
const styles = (theme) => ({
  paper: {
    marginTop: theme.spacing(8),
    display: "flex",
    flexDirection: "column",
    alignItems: "center",
  },
  avatar: {
    margin: theme.spacing(1),
    backgroundColor: theme.palette.secondary.main,
  },
  form: {
    width: "100%", // Fix IE 11 issue.
    marginTop: theme.spacing(1),
  },
  submit: {
    margin: theme.spacing(3, 0, 2),
  },
});

export default withStyles(styles, { withTheme: true })(LoginPage);
